export default __webpack_public_path__ + "static/media/ZingProjectH2.202cac0e.png";